//TODO: move all constants here
export class Constants {
  public static User = class {
    public static readonly seekerFields = {
      name: { name: 'Name', title: 'نام و نام خانوادگی', required: true },
      seekerPhoto: { name: 'Seeker.Photo', title: '' },
      jobTitles: { name: 'Seeker.JobAlertSettings.JobTitles', title: 'عنوان‌های شغلی', config: { multi: true, showOnlyConsiderSearches: true, showSuggestions: true } },
      karpashaNotes: { name: 'Seeker.JobAlertSettings.KarpashaNotes', title: 'توضیحات شغل' },
      location: { name: 'Seeker.Location', title: 'محل سکونت', config: { showDistrict: true, showPreferredLocation: true, showReadyToRelocate: true } },
      degree: { name: 'Seeker.Degree', title: 'آخرین مدرک تحصیلی' },
      age: { name: 'Seeker.Birthday', title: 'تاریخ تولد' },
      gender: { name: 'Seeker.Gender', title: 'جنسیت' },
      marital: { name: 'Seeker.MaritalStatus', title: 'وضعیت تاهل' },
      military: { name: 'Seeker.MilitaryStatus', title: 'وضعیت نظام‌وظیفه' },
      insurance: { name: 'Seeker.JobAlertSettings.NeedInsurance', title: 'نیاز به بیمه' },
      salary: { name: 'Seeker.JobAlertSettings.Salary', title: 'حداقل دستمزد' },
      skills: { name: 'Seeker.Skills', title: 'مهارت‌های شغلی' },
      jobtype: { name: 'Seeker.JobAlertSettings.JobTypes', title: 'نوع قرارداد استخدام', config: { multi: true } },
      employed: { name: 'Seeker.JobAlertSettings.IsEmployed', title: 'وضعیت اشتغال شما در حال حاضر' },
      experience: { name: 'Seeker.AskExperience', title: 'سابقه کار' },
      openToWork: { name: 'Seeker.JobAlertSettings.OpenToWork', title: 'از کی می‌تونی کار جدید شروع کنی' },
      workHours: { name: 'Seeker.JobAlertSettings.WorkHoursNote', title: 'توضیحات ساعت کاری' },
      driving: { name: 'Seeker.DrivingLicenses', title: 'گواهینامه‌های رانندگی' },
      certificates: { name: 'Seeker.Certificates', title: 'گواهینامه‌های دوره‌های حرفه‌ای و آموزشی' },
      language: { name: 'Seeker.LanguageSkills', title: 'زبان‌هایی که تسلط دارید' },
      exams: { name: 'Seeker.Exams', title: 'مدارک آزمون‌ها' },
    };
  };
  public static Job = class {
    public static readonly jobFields = {
      title: { name: 'Title', title: 'شغل' },
      jobTitle: { name: 'JobTitle', title: 'عنوان‌های شغلی', config: { showSuggestions: true } },
      description: { name: 'Description', title: 'متن آگهی', },
      karpashaInfo: { name: 'KarpashaInfo', title: '', },
      location: { name: 'Location', title: '', config: { showDistrict: true, showLocationInfo: true } },
      age: { name: 'Age', title: '' },
      gender: { name: 'Gender', title: '' },
      marital: { name: 'MaritalStatus', title: '' },
      degree: { name: 'Degree', title: '' },
      experience: { name: 'Experience', title: '' },
      workHours: { name: 'WorkHours', title: '' },
      military: { name: 'MilitaryExcludeNotServed', title: '' },
      insurance: { name: 'HasInsurance', title: '' },
      salary: { name: 'Salary', title: '' },
      skills: { name: 'RequiredSkills', title: '' },
      jobType: { name: 'JobTypes', title: '', config: { multi: true } },
      driving: { name: 'DrivingLicenses', title: 'گواهینامه‌های رانندگی' },
      certificates: { name: 'Certificates', title: 'گواهینامه‌ها' },
      language: { name: 'Languages', title: 'زبان‌هایی که تسلط دارید' },
      exams: { name: 'Exams', title: 'مدارک آزمون‌ها' },
    };
    public static readonly bonuses = ['ناهار', 'بیمه تکمیلی', 'سرویس ایاب و ذهاب', 'اسکان', 'ساعت کاری منعطف'];
    public static readonly jobRejectReasons = [
      { reason: 'شماره پیدا نشد', closeAd: false },
      { reason: 'آگهی حذف یا منقضی شده', closeAd: true },
      { reason: 'آگهی استخدام نیست', closeAd: true },
      { reason: 'مشکوک به کلاهبرداری است', closeAd: true },
      { reason: 'کیفیت آگهی خوب نیست', closeAd: false },
      { reason: 'کارفرما پاسخگو نیست', closeAd: false },
      { reason: 'استخدام کرده', closeAd: true },
      { reason: 'از استخدام منصرف شده', closeAd: true },
      { reason: 'با کاریابی کار نمی‌کند', closeAd: false },
    ];

  };
  public static Translations = class {
    public static readonly drivingLicense: Record<string, string> = { '1': 'پایه یک', '2': 'پایه دو', '3': 'پایه سه', '4': 'ویژه', '5': 'موتورسیکلت' };
    public static readonly jobStatus: Record<number, string> = { '1': 'در انتظار پرداخت', '2': 'در انتظار تایید', '3': 'مرجوع', '4': 'تایید شده', '5': 'متوقف شده', '6': 'خاتمه یافته', '7': 'آرشیو شده' };
    public static readonly jobLeadStatus: Record<string, string> = { '-1': 'رد شده', '0': 'در حال بررسی', '1': 'تایید شده' };
    public static readonly recruitLeadStatus: Record<string, string> = { '-1': '', '0': 'xx', '1': 'xx', '2': 'در انتظار تکمیل', '3': 'در انتظار تایید', '4': 'تایید شده' };
    public static readonly resourceStatus: Record<string, string> = { '-1': '', '0': 'در انتظار تایید', '1': 'تایید شده', '2': 'رد شده', '3': 'متوقف شده', '4': 'خاتمه یافته', '5': 'آرشیو شده' };
    public static readonly resourceType: Record<string, string> = {
      'exam': 'نمونه سوال و آزمون',
      'education': 'منابع آموزشی',
      'template': 'نمونه فرم و قرارداد',
      'guide': 'مقررات و دستورالعمل',
      'article': 'مقاله',
      'book': 'کتاب',
      'questioner': 'پرسشنامه و ارزیابی',
      'software': 'نرم‌افزار تخصصی',
      'podcast': 'پادکست',
			'course': 'دوره آموزشی',
    };
    public static readonly resourceTypeIntro: Record<string, string> = {
      'exam': 'نمونه سوالات استخدامی بانک‌ها، سازمان‌های دولتی و شرکت‌های معتبر؛ سوالات آزمون‌های تخصصی، شغلی و حرفه‌ای',
      'education': 'منابع آموزشی، ویدیوها و کتاب‌های مرتبط به شغل‌ها و حرفه‌های گوناگون',
      'template': 'نمونه فرم‌های مرتبط با شغل‌ها و حرفه‌های مختلف؛ قراردادهای استخدامی؛ نمونه فرم‌های مرتبط با مالیات و بیمه و ...؛ قالب‌ها و فایل‌های آماده برای کاربردهای گوناگون',
      'guide': 'مقررات و دستورالعمل‌های مرتبط با شغل‌ها و حرفه‌های مختلف؛ مقررات و دستورالعمل‌های مرتبط با مالیات و بیمه و ...؛ راهنماها و راهبردهای مرتبط با شغل‌ها و حرفه‌های گوناگون',
      'article': 'مقالات آموزشی و حرفه‌ای؛ راهنماهای ارتقای شغلی و فردی؛ نحوه ایجاد رزومه؛ حضور در مصاحبه استخدامی و ...',
      'book': 'کتاب‌های مرتبط با شغل‌ها و حرفه‌های گوناگون، ارتقای فردی و شغلی، آموزش و یادگیری، کسب و کار، ...',
      'questioner': 'پرسشنامه‌های ارزیابی و تشخیصی؛ پرسشنامه‌های ارزیابی شغلی و حرفه‌ای؛ پرسشنامه‌های ارزیابی روان‌شناختی و ...',
      'software': 'نرم‌افزارهای تخصصی و حرفه‌ای، مهندسی، محاسباتی و آماری، مالی و حسابداری، مدیریت و ...',
      'podcast': 'پادکست‌های مرتبط با شغل‌ها و حرفه‌های گوناگون؛ پادکست‌های آموزشی و ارتقای شغلی و فردی؛ پادکست‌های مرتبط با مدیریت و کسب و کار و ...',
			'course': 'دوره‌های آموزشی مرتبط با مقاطع تحصیلی و مهارت‌های شغلی مختلف، مانند دوره‌های برنامه‌نویسی، حسابداری، مدیریت و ...'
    };
    public static readonly RtwadStatus: Record<string, string> = { 'NotPaid': 'در انتظار پرداخت', 'Pending': 'در انتظار تایید', 'Started': 'منتشر شده', 'Rejected': 'رد شده', 'Archived': 'آرشیو شده' };

  };
  public static readonly languages: string[] = ['ترکی آذربایجانی', 'ترکی استانبولی', 'کردی', 'عربی', 'انگلیسی', 'آلمانی', 'روسی', 'اسپانیایی', 'چینی', 'ژاپنی'];
  public static readonly degrees = ['زیر دیپلم', 'دیپلم', 'کاردانی', 'کارشناسی', 'کارشناسی‌ارشد', 'دکترا',];

  public static Events = class {
    public static readonly openSalaryCalc = 'openSalaryCalc';
  }

}
